<mat-card class="stepper">

  <div class="allSteps">
    <!-- Form Name :  <input placeholder="Add Form Name" [(ngModel)]="hTMLFormName" maxlength="100"  required>  -->

    <div class="createCore">
      <mat-slide-toggle matTooltip="Create or Update {{CoreName}} when Sent" color="primary" [(ngModel)]="selected3cType"></mat-slide-toggle>
    </div>

    <div class="pNameNumber saveName">

      <div class="active step">
        <div class="stepStatus">
          <span class="nmbr">{{currentStep}}</span>
        </div>
      </div>
      <input type="text" (ngModelChange)="ChangePageName($event)" [(ngModel)]="currentPageName"
        placeholder="Enter page name">

    </div>
    <span class="nextPre">
      <button mat-icon-button color="primary" [disabled]="!(currentStep>1)" matTooltip="Previous page"
        (click)="ChangeStep(1)">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <button mat-icon-button color="primary" [disabled]="!(currentStep<controlAlignArray.length)"
        matTooltip="Next Page" (click)="ChangeStep(2)">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </span>

    <button mat-icon-button color="basic" class="addStepBtn" matTooltip="Add Page"
      (click)="AddStep()"><mat-icon>library_add</mat-icon></button>

    <button mat-icon-button color="" matTooltip="Hide AI Editor" (click)="hideControls()" ><mat-icon>filter_1</mat-icon></button> 

    <button color="primary" class="globalAiBtn ml-10" mat-icon-button matTooltipClass="tooltip" matTooltip="AI" (click)="openAIPdfPopup(AIPdfpopUp)">
      AI
    </button> 

    <button  class="ml-10" mat-icon-button matTooltipClass="tooltip" matTooltip="3rd Party Url Accept Configuration" (click)="Open3rdPartyURL(PartyURLpopUp)">
      <mat-icon>room_preferences</mat-icon>
    </button> 

    <button class="ml-10" mat-icon-button matTooltipClass="tooltip" matTooltip="Configure Form Selection Parameter" 
     (click)="OpenConfigureFormSelection(ConfigureFormSelectionpopUp)">
      <mat-icon>settings_applications</mat-icon>
    </button> 

    <div class="txtColor">
      <div class="textViewColorButton" [ngStyle]="{'background':backgroundColorForm}"></div>
      <input type="color" class="" [(ngModel)]="backgroundColorForm" (input)="onChangeBackgroundColorForm($event.target.value)" />
    </div>

  </div>

  <div class="stepAct">

    <button *ngIf="FormId>0" mat-flat-button color="primary" [disabled]="!SaveButtonDisbled" matTooltip="Save"
      (click)="UpdateHtMLFormFromSave()">
      Save
    </button>
    <button mat-flat-button color="primary" [disabled]="!SaveButtonDisbled" matTooltip="Finish"
      (click)="OpenPopUpForFolder(saveTemp)">
      Finish
    </button>
    <!-- <button mat-flat-button color="primary"  matTooltip="Save" (click)="AddHtMLForm()" >
      Save
    </button> -->
  </div>

</mat-card>

<div class="canvas">

  <mat-card class="lblockPanel" [ngClass]="{ active: showToolsLeft }">
    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon>construction</mat-icon>
        </ng-template>
        <div class="allFolder">

          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
          *ngFor=" let field of TextSinglehWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
          (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('TextSingle')">
          <mat-icon>text_format</mat-icon>Text Only
        </mat-card>
        <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
          *ngFor=" let field of ParagraphWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
          (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Paragraph')">
          <mat-icon> notes</mat-icon>Paragraph Only
        </mat-card>

          <mat-card class="tool" *ngFor="let field of singlLineWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'move'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Textbox')">
            <mat-icon>power_input</mat-icon>Single Line
          </mat-card>

          <mat-card class="tool" *ngFor="let field of multiLineWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Textarea')">
            <mat-icon>dehaze</mat-icon>Multi-Line
          </mat-card>


          <mat-card class="tool" *ngFor="let field of numberWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Number')">
            <mat-icon>filter_1</mat-icon>Number
          </mat-card>



          <mat-card class="tool" *ngFor="let field of dropdownWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Dropdown')">
            <mat-icon>arrow_drop_down_circle</mat-icon>Dropdown
          </mat-card>

          <mat-card class="tool" *ngFor="let field of checkWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Checkbox')">
            <mat-icon>check_box</mat-icon> Check Box
          </mat-card>



          <mat-card id='table_chartleftpanel' class="tool" *ngFor="let field of tableWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Table')">
            <mat-icon>table_chart</mat-icon>Table
          </mat-card>

          <mat-card class="tool" *ngFor="let field of signatureWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Signature')">
            <mat-icon>create</mat-icon>Signature
          </mat-card>

          <mat-card class="tool" *ngFor="let field of initialsWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Initials')">
            <mat-icon>gesture</mat-icon>Initials
          </mat-card>

          <mat-card class="tool" *ngFor="let field of dateWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Date')">
            <mat-icon>event_available</mat-icon>Date
          </mat-card>

          <mat-card class="tool" *ngFor="let field of timeWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Time')">
            <mat-icon>schedule</mat-icon>Time
          </mat-card>

          <mat-card class="tool" *ngFor="let field of LocationWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('location')">
            <mat-icon>location_on</mat-icon>Location
          </mat-card>

          <mat-card class="tool" *ngFor="let field of fileWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('File')">
            <mat-icon>insert_drive_file</mat-icon>File
          </mat-card>

          <mat-card class="tool" *ngFor="let field of buttonWithFields" [dndDraggable]="field"
            [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Button')">
            <mat-icon>smart_button</mat-icon>Button
          </mat-card>

          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of imageWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Image')">
            <mat-icon>wallpaper</mat-icon>Image
          </mat-card>

          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of embedImageWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('embedImage')">
            <mat-icon>center_focus_weak</mat-icon>Embed Image
          </mat-card>

          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of DeviderWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Devider')">
            <mat-icon>remove</mat-icon>Divider
          </mat-card>
          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of spaceWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Space')">
            <mat-icon>space_bar</mat-icon>Space
          </mat-card>

          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of MCQWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('MCQ')">
            <mat-icon>check_circle_outline</mat-icon>MCQ
          </mat-card>
          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of URLhWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('URL')">
            <mat-icon>link</mat-icon>URL
          </mat-card>
          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of TrueFalseWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('TrueFalse')">
            <mat-icon>check</mat-icon>
            True/False
          </mat-card>
          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of FeedbackWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Feedback')">
            <mat-icon> comment</mat-icon>Feedback
          </mat-card>
          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of RatingWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Rating')">
            <mat-icon>star</mat-icon>Rating
          </mat-card>
          <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
            *ngFor=" let field of HtmlEditorWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
            (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('HtmlEditor')">
            <mat-icon>star</mat-icon>HTML Editor
          </mat-card>
        </div>

      </mat-tab>



      <mat-tab *ngIf="showAdd3CButton">
        <ng-template mat-tab-label>
          <svg xmlns="http://www.w3.org/2000/svg" width="33" height="17.999" viewBox="0 0 33 16.999">
            <path class="customFieldIcon" id="Subtraction_1" data-name="Subtraction 1"
              d="M31,16.5H2A1.5,1.5,0,0,1,.5,15V2A1.5,1.5,0,0,1,2,.5H31A1.5,1.5,0,0,1,32.5,2V15A1.5,1.5,0,0,1,31,16.5ZM6.072,4.469V13H7.2V4.469Z"
              transform="translate(0 0)" fill="none" stroke="#e0e0e0" stroke-width="2" />
          </svg>
        </ng-template>

        <div class="allFolder">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> {{CoreName}} </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="customFields">
                <button mat-icon-button class="addField" color="primary" (click)="createField('Core')">
                  <mat-icon>add</mat-icon>
                </button>

                <mat-form-field appearance="fill">
                  <mat-label>Select Type</mat-label>
                  <mat-select (selectionChange)="getAllCoreSubfolderFields($event.value)" name="selectedCorePeopleType">
                    <mat-option *ngFor="let subFolder of coreSubFolderList" [value]="subFolder.subFolderID">
                      {{ subFolder.folderName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-card class="field" *ngFor=" let field of corefieldsList " [dndDraggable]="field"
                  [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)">
                  <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
                </mat-card>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> {{CompanyName}} </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="customFields">
                <button mat-icon-button class="addField" color="primary" (click)="createField('Company')">
                  <mat-icon>add</mat-icon>
                </button>

                <mat-form-field appearance="fill">
                  <mat-label>Select Type</mat-label>
                  <mat-select (selectionChange)="getAllCompanySubfolderFields($event.value)"
                    name="selectedCompanyPeopleType">
                    <mat-option *ngFor="let subFolder of companySubFolderList" [value]="subFolder.subFolderID">
                      {{ subFolder.folderName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-card class="field" *ngFor=" let field of companyfieldsList" [dndDraggable]="field"
                  [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)">
                  <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
                </mat-card>

              </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> {{ContactName}} </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="customFields">
                <button mat-icon-button class="addField" color="primary" (click)="createField('Contact')">
                  <mat-icon>add</mat-icon>
                </button>

                <mat-form-field appearance="fill">
                  <mat-label>Select Type</mat-label>
                  <mat-select (selectionChange)="getAllContactSubfolderFields($event.value)"
                    name="selectedCompanyPeopleType">
                    <mat-option *ngFor="let subFolder of contactSubFolderList" [value]="subFolder.subFolderID">
                      {{ subFolder.folderName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <mat-card class="field" *ngFor=" let field of contactfieldsList" [dndDraggable]="field"
                  [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)">
                  <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
                </mat-card>

              </div>
            </mat-expansion-panel>

          </mat-accordion>
        </div>
      </mat-tab>


    </mat-tab-group>

    <div class="HeaderFooter">
      <mat-checkbox color="primary" [checked]="ShowHeader" (change)='showHeader($event)'>Include Header</mat-checkbox>
      <mat-checkbox color="primary" [checked]="ShowFooter" (change)='showFooter($event)'>Include Footer</mat-checkbox>
      <mat-checkbox color="primary" [checked]="IsCheckIn" (change)='checkIn($event)'>CheckIn/CheckOut Form</mat-checkbox>
    </div>

  </mat-card>


  <div class="formWrapper" [ngStyle]="{'background-color': backgroundColorForm}">

    <div class="documentHolder example-boundary">
      <button mat-fab color="primary" class="toolsBtn" (click)="showTools()" cdkDragBoundary=".example-boundary"
        cdkDrag>
        <mat-icon *ngIf="showToolsLeft">close </mat-icon>
        <mat-icon *ngIf="!showToolsLeft">construction</mat-icon>
      </button>

      <ng-container *ngIf="ShowHeader">
        <ng-container *ngFor="let item of HeaderFooter">

          <div class="iframe-drag-bounds-header" *ngIf="item.type=='Header'">

            <div class="customUpdate">
              <div class="bannerText">
                <input type="text" placeholder="Enter banner heading" [(ngModel)]="headerText"
                  [ngStyle]="{'color': item.color,'font-family': item.fontfamily,'font-size': item.fontSize}" (click)="HeaderTextChanges(item)"
                  (input)="addHeaderText($event)">
              </div>
              <div class="bgbanner">
                <div class="bannerUpload" *ngIf='item.ImageData.length==0'>
                  <mat-icon>cloud_upload</mat-icon>
                  Upload Banner (.jpg, .png)
                </div>

                <div *ngFor="let img of item.ImageData" class="uploadedData">
                  <img *ngIf='img.Imageurl' [src]="img.Imageurl" />
                </div>

                <input type="file" class="form-control" (change)="onSelectImageForHeaderFooter($event,'Header')"
                  accept="image/*">

                <div class="bannerUpload" *ngIf='item.ImageData.length==0'>
                  <i>1200x100</i>
                  Suggested Size
                </div>


              </div>
            </div>

          </div>
        </ng-container>
      </ng-container>


      <div class="iframe-drag-bounds" >
        <form autocomplete="off">
          <div class="" id="docSign" #content dndDropzone (dndDrop)="onDrop($event)">


            <section cdkDropList class="docSign"
              [cdkDropListData]="controlAlignArray.length>0?controlAlignArray[currentStep-1].fields:[]"
              (cdkDropListDropped)="drop($event)">

              <ng-container *ngFor="let data of FindCurrentStep(controlAlignArray);let i= index;" style="width:100%">

                <ng-container *ngFor="let item of data.fields;let i= index;">

                  <section [ngClass]="getClass(item)"  cdkDrag>
                    <section class="controlContainer" [id]="item.id" *ngIf="item.fieldJson.fieldTypeName=='HtmlEditor'"
                      (click)="OpentoolDetail('HtmlEditor')" (click)="OpentoolDetailText(data,item.id,$event)">
                      

                      <ckeditor [config]="editorConfig" (click)="LoadSelectedAIDocs(item.id)" (click)="OpentoolDetail('HtmlEditor')" [ngModel]="item.fieldJson.selectedValue"
                        editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js" [name]="item.id"
                        [config]="ckEditorConfig" debounce="500" (ready)="onCkEditorReady($event)"
                        (ngModelChange)="onChangeCkEditor($event,data,item)" [config]="editorConfig">
                      </ckeditor>
                      
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <button (click)="fullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="halfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button>
                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>
                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Textbox'"
                      (click)="OpentoolDetail('Textbox')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('Textbox')" (click)="OpentoolDetailText(data,item.id,$event)">
                       
                        {{item.fieldJson.labelName}}</label>
                      <input type="text"
                        [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                        maxlength="40" placeholder="{{item.fieldJson.fieldName}}"
                        [attr.value]='item.fieldJson.selectedValue' (input)="onChanges($event.target.value,data,item)"
                        (click)="OpentoolDetail('Textbox')" (click)="OpentoolDetailText(data,item.id,$event)" />
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>


                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Textarea'"
                      (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Textarea')">
                      <label (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Textarea')">
                       {{item.fieldJson.labelName}}</label>

                      <textarea placeholder="{{item.fieldJson.fieldName}}" id="{{item.id}}" [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 
                   'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily,
                   'height': item.fieldJson.offsetHeight +'px'}" [innerHTML]='item.fieldJson.selectedValue'
                        (input)="onChanges($event.target.value,data,item)"
                        (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Textarea')"
                        (mouseup)="onresizeMaybe(data,item)">
    </textarea>


                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button> 

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Number'"
                      (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Number')">
                      <label (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Number')">
                       
                        {{item.fieldJson.labelName}}</label>
                      <input type="number" pattern="[0-9]+([\.,][0-9]+)?" placeholder="{{item.fieldJson.fieldName}}"
                        [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 
                'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                        [attr.value]='item.fieldJson.selectedValue' (input)="onChanges($event.target.value,data,item)"
                        (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Number')" />
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Dropdown'"
                      (click)="OpentoolDetailDropDown(data,item.id,$event)" (click)="OpentoolDetail('Dropdown')">
                      <label (click)="OpentoolDetailDropDown(data,item.id,$event)" (click)="OpentoolDetail('Dropdown')">
                      
                        {{item.fieldJson.labelName}}</label>
                      <mat-form-field appearance="outline" (click)="OpentoolDetailDropDown(data,item.id,$event)"
                        (click)="OpentoolDetail('Dropdown')">
                        <!-- <label>{{item.fieldJson.fieldName}}</label>    -->
                        <mat-select
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)" (click)="OpentoolDetail('Dropdown')"
                          placeholder={{item.selectedValue}} (selectionChange)="setDdlValue($event,data,item)"
                          [attr.value]="item.fieldJson.selectedValue">

                          <mat-option
                            [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                            *ngFor="let drp of item.fieldJson.fillList" [value]="drp.val">
                            {{ drp.val }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>


                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Date'"
                      (click)="OpentoolDetail('Date')" (click)="OpentoolDetailText(data,item.id,$event)"
                      >
                      <label (click)="OpentoolDetail('Date')" (click)="OpentoolDetailText(data,item.id,$event)">
                       
                        {{item.fieldJson.labelName}}</label>
                      <mat-form-field appearance="outline" (click)="OpentoolDetail('Date')"
                        (click)="OpentoolDetailText(data,item.id,$event)">
                        <input matInput
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize , 'font-family': item.fieldJson.fontfamily}"
                          [attr.Value]="item.fieldJson.selectedValue|date:'MM/dd/yyyy'"
                          placeholder={{item.fieldJson.fieldName}} readonly
                          (input)="onChangesDate($event.target.value,data,item)"
                          (dateChange)="onChangesDate($event.target.value,data,item)" (click)="OpentoolDetail('Date')"
                          (click)="OpentoolDetailText(data,item.id,$event)" (click)="basicDatepicker.open()" [matDatepicker]="basicDatepicker" />
                        <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #basicDatepicker></mat-datepicker>
                      </mat-form-field>
                      <div class="contorlTools">
                        <div class="lhOpt">
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>
                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Time'"
                      (click)="OpentoolDetail('Time')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('Time')" (click)="OpentoolDetailText(data,item.id,$event)">
                        
                        {{item.fieldJson.labelName}}</label>
                      <mat-form-field appearance="outline" (click)="OpentoolDetail('Time')"
                        (click)="OpentoolDetailText(data,item.id,$event)">
                        <input
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          aria-label="default time" (click)="OpentoolDetail('Time')"
                          (click)="OpentoolDetailText(data,item.id,$event)" matInput
                          placeholder={{item.fieldJson.fieldName}} [attr.Value]='item.fieldJson.selectedValue' readonly>
                        <ngx-material-timepicker-toggle matSuffix
                          [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                        <ngx-material-timepicker (timeSet)="onChanges($event,data,item)" #toggleTimepicker>
                        </ngx-material-timepicker>
                      </mat-form-field>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Space'"
                      (click)="OpentoolDetail('Space')">
                      <label>&nbsp;</label>
                      <div appearance="outline" (click)="OpentoolDetail('Space')">
                        <input type="text"
                        readonly
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'height': item.fieldJson.topMargin, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="Blank  space" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Textbox')"
                          (click)="OpentoolDetailText(data,item.id,$event)" />
                      
                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">

    
                         
                        <!-- <button (click)="fullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="halfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Devider'"
                      (click)="OpentoolDetail('Devider')">
                      <label>&nbsp;</label>
                      <div appearance="outline" (click)="OpentoolDetail('Devider')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="Divider" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Textbox')"
                          (click)="OpentoolDetailText(data,item.id,$event)" />
                        <span class="form-group-divider" [ngStyle]="{
                          'display': 'block',
                          'background-color': 'grey',
                          'width': '100%',
                          'height': '2px'}" (click)="OpentoolDetail('Devider')">
                        </span>
                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="fullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="halfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='TextSingle'"
                      (click)="OpentoolDetail('TextSingle')">
                    
                      <div appearance="outline" (click)="OpentoolDetail('TextSingle')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="{{item.fieldJson.fieldName}}" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Textbox')"
                          (click)="OpentoolDetailText(data,item.id,$event)" />

                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>


                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='URL'"
                      (click)="OpentoolDetail('URL')">
                      <label (click)="OpentoolDetail('URL')">
                        
                        {{item.fieldJson.fieldName}}
                      </label>
                      <div appearance="outline" (click)="OpentoolDetail('URL')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="{{item.fieldJson.fieldName}}" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Textbox')"
                          (click)="OpentoolDetailText(data,item.id,$event)" />

                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Paragraph'"
                      (click)="OpentoolDetail('Paragraph')">
                     
                      <div class="multiPhragraph" (click)="OpentoolDetail('Paragraph')">
                        <textarea placeholder="{{item.fieldJson.fieldName}}" id="{{item.id}}" [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 
                   'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily,
                   'height': item.fieldJson.offsetHeight +'px'}" [innerHTML]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)"
                          (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Textarea')"
                          (mouseup)="onresizeMaybe(data,item)">
    </textarea>
                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='MCQ'"
                      (click)="OpentoolDetail('MCQ')">
              
                      <div appearance="outline" (click)="OpentoolDetail('MCQ')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="{{item.fieldJson.fieldName}}" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Textbox')"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)" />

                        <mat-radio-group style="display: grid" aria-label="Select an option"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)">
                          <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px"
                            *ngFor="let drp of item.fieldJson.fillList" [value]="drp.val">
                            {{ drp.val }}</mat-radio-button>
                        </mat-radio-group>
                        <!-- <mat-form-field appearance="outline" (click)="OpentoolDetailDropDown(data,item.id,$event)" (click)="OpentoolDetail('Dropdown')">
        <label>{{item.fieldJson.fieldName}}</label>
      <mat-select 
       [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
       (click)="OpentoolDetailDropDown(data,item.id,$event)"
       (click)="OpentoolDetail('Dropdown')" 
       placeholder={{item.selectedValue}}
       (selectionChange)="setDdlValue($event,data,item)" 
       [attr.value]="item.fieldJson.selectedValue" >
      
       <mat-option [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
        *ngFor="let drp of item.fieldJson.fillList" [value]="drp.val">
         {{ drp.val }}
       </mat-option>
     </mat-select>
    </mat-form-field> -->
                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                        <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>


                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='TrueFalse'"
                      (click)="OpentoolDetail('TrueFalse')">
                   


                      <div appearance="outline" (click)="OpentoolDetail('TrueFalse')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="{{item.fieldJson.fieldName}}" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('TrueFalse')"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)" />

                        <mat-radio-group style="display: grid" aria-label="Select an option"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)">
                          <div class="" style="display:flex;">
                            <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px"
                              *ngFor="let drp of item.fieldJson.fillList" [value]="drp">
                              {{drp}}
                              <!-- <mat-icon *ngIf="drp=='True'">check</mat-icon>
            <mat-icon *ngIf="drp=='False'">close</mat-icon> -->
                            </mat-radio-button>
                          </div>
                        </mat-radio-group>
                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>
                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Feedback'"
                      (click)="OpentoolDetail('Feedback')">
                      

                      <div appearance="outline" (click)="OpentoolDetail('Feedback')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="{{item.fieldJson.fieldName}}" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Feedback')"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)" />

                        <!-- <mat-radio-group style="display: grid" aria-label="Select an option" (click)="OpentoolDetailDropDown(data,item.id,$event)">
        <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px" *ngFor="let drp of item.fieldJson.fillList" [value]="drp">
         
        <mat-icon *ngFor="let i of Arr(drp).fill(1)">star</mat-icon>
        </mat-radio-button>
        </mat-radio-group> -->

                        <div class="starHolder">
                          <span *ngFor="let drp of item.fieldJson.fillList">
                            <span (click)="selectFeedback(drp,item,data)" [ngClass]="{'active': drp.active === true}">
                              <mat-icon>task_alt</mat-icon>
                              {{ drp.val}}
                            </span>
                          </span>
                        </div>


                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>

                          <button (click)="fullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="halfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button>
                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>
                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Rating'"
                      (click)="OpentoolDetail('Rating')">
                     


                      <div appearance="outline" (click)="OpentoolDetail('Rating')">
                        <input type="text"
                          [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                          placeholder="{{item.fieldJson.fieldName}}" [attr.value]='item.fieldJson.selectedValue'
                          (input)="onChanges($event.target.value,data,item)" (click)="OpentoolDetail('Rating')"
                          (click)="OpentoolDetailDropDown(data,item.id,$event)" />

                        <!-- <mat-radio-group style="display: grid" aria-label="Select an option" (click)="OpentoolDetailDropDown(data,item.id,$event)">
        <mat-radio-button (change)="McqRadioChange($event,data,item)" style="padding: 5px" *ngFor="let drp of item.fieldJson.fillList" [value]="drp">
         
        <mat-icon *ngFor="let i of Arr(drp).fill(1)">star</mat-icon>
        </mat-radio-button>
        </mat-radio-group> -->

                        <div class="starRatingHolder">
                          <span *ngFor="let drp of item.fieldJson.fillList">
                            <span (click)="selectRating(drp,item,data)" [ngClass]="{'active': drp.active === true}">
                              <mat-icon>star</mat-icon>
                            </span>
                          </span>
                        </div>


                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button>
                           -->
                           <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                           matTooltip="Move Control">
                           <mat-icon>drag_indicator</mat-icon>
                         </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>
                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Location'"
                      (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Location')">
                      <label (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Location')">
                       
                        {{item.fieldJson.labelName}}</label>
                      <div class="customUpdate" (click)="OpentoolDetailText(data,item.id,$event)"
                        (click)="OpentoolDetail('Location')" (click)="fetchLocation(data,item.id)">
                        <span *ngIf='!item.Lat && !item.Long'>
                          <mat-icon>location_on</mat-icon>
                          Location
                        </span>
                        <ng-container *ngIf='item.fieldJson.Lat && item.fieldJson.Long'>
                          <h3
                            [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize , 'font-family': item.fieldJson.fontfamily}">
                            Lat : {{item.fieldJson.Lat}}
                            Long: {{item.fieldJson.Long}}
                          </h3>
                        </ng-container>

                      </div>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <!-- <button (click)="FullWidth(data,item)" color="primary" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>
                          <button (click)="HalfWidth(data,item)" color="" class="" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>
                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>

                        </div>
                      </div>
                    </section>

                    <section class="controlContainer specialButton" *ngIf="item.fieldJson.fieldTypeName=='Button'"
                      (click)="OpentoolDetail('Button')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('Button')" (click)="OpentoolDetailText(data,item.id,$event)">
                       
                        {{item.fieldJson.labelName}}</label>

                      <button mat-flat-button
                        [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily,
                        'background-color': item.fieldJson.backgroundColor}"
                        [value]='' class="btnGlobalButton" (click)="OpentoolDetail('Button')"
                        (click)="OpentoolDetailText(data,item.id,$event)">{{item.fieldJson.buttonName}}
                      </button>
                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="fullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="halfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer fullWidth" *ngIf="item.fieldJson.fieldTypeName=='Checkbox'"
                      (click)="OpentoolDetail('Checkbox')"
                      (click)="OpentoolDetailCheckBox(data,item.id,item.fieldJson.fillList,$event)">
                      <label (click)="OpentoolDetail('Checkbox')"
                        (click)="OpentoolDetailCheckBox(data,item.id,item.fieldJson.fillList,$event)">
                        

                        {{item.fieldJson.labelName}}
                      </label>

                      <div class="radioHolder" (click)="OpentoolDetail('Checkbox')"
                        (click)="OpentoolDetailCheckBox(data,item.id,item.fieldJson.fillList,$event)">

                        <div *ngFor="let ele of item.fieldJson.fillList">
                          <label
                            [ngStyle]="{'color': item.fieldJson.fontColor, 'text-align': item.fieldJson.textalign, 'font-weight': item.fieldJson.fontstyle, 'font-style': item.fieldJson.fontweight, 'text-decoration': item.fieldJson.textdecoration, 'font-size': item.fieldJson.fontSize, 'font-family': item.fieldJson.fontfamily}"
                            class="checkboxItem" (click)="OpentoolDetail('Checkbox')"
                            (click)="OpentoolDetailCheckBox(data,item.id,ele.id,$event)">

                            <input type="checkbox" [checked]='ifChkChecked(item.fieldJson.id,data,ele.id)'
                              [attr.checked]="ifChkChecked(item.fieldJson.id,data,ele.id)? 'checked' : null"
                              (click)="OnChangeCheckBox($event,ele.val,item,data,ele.id)">
                            {{ele.val}}

                          </label>
                        </div>
                      </div>

                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>
                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>


                    <section class="controlContainer " *ngIf="item.fieldJson.fieldTypeName=='Table'"
                      (click)="OpentoolDetail('Table')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('Table')" (click)="OpentoolDetailText(data,item.id,$event)">
                        
                        {{item.fieldJson.labelName}}</label>
                      <table class="formTable" style="border: 1px;" (click)="OpentoolDetail('Table')"
                        (click)="OpentoolDetailText(data,item.id,$event)">
                        <tbody (click)="OpentoolDetailtbl(data,item.id,$event)">
                          <tr *ngFor="let row of item.fieldJson.rows;let r=index">
                            <td *ngFor="let column of item.fieldJson.column;let c=index">
                              <input id='{{item.id}}txt-{{r+1}}{{c+1}}'
                                [attr.value]="getColumnValue(data,item.id,r+1,c+1)"
                                (input)="onTableChange($event,data,item.id)" type="text" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="setWidth(data,item)"  mat-icon-button matTooltipClass="tooltip" matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button> 
                
                          <button (click)="centerBlock(data,item)"   mat-icon-button matTooltipClass="tooltip" matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button> -->
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>


                    <section class="controlContainer customUpdate" *ngIf="item.fieldJson.fieldTypeName=='File'"
                      (click)="OpentoolDetail('File')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('File')" (click)="OpentoolDetailText(data,item.id,$event)">
                       
                        {{item.fieldJson.labelName}}</label>
                      <div (click)="OpentoolDetail('File')" (click)="OpentoolDetailText(data,item.id,$event)"
                        class="fileOuter">

                        <div *ngFor="let file of item.fieldJson.FileData" class="uploadedData">
                          <p>{{file.FullPath}}</p>
                        </div>

                        <span *ngIf='item.fieldJson.FileData.length==0'>
                          <mat-icon>cloud_upload</mat-icon>
                          Upload File

                        </span>


                        <input type="file" (change)="onSelectFile($event,data,item.id)" class="form-control"
                          placeholder="{{item.fieldName}}">

                      </div>

                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="setWidth(data,item)"  mat-icon-button matTooltipClass="tooltip" matTooltip="Width">

                            <mat-icon>width_normal</mat-icon>
                          </button> 
                
                          <button (click)="centerBlock(data,item)"   mat-icon-button matTooltipClass="tooltip" matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>


                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Signature'"
                      (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Signature')">
                      <label (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Signature')">
                       
                        {{item.fieldJson.labelName}}</label>

                      <div class="customUpdate" (click)="OpentoolDetailText(data,item.id,$event)"
                        (click)="OpentoolDetail('Signature')" (click)="OpenSignPopup(AddSignature,data,item,$event)">

                        <span
                          *ngIf='!item.fieldJson.signatureBase64 && !item.fieldJson.signatureText && item.fieldJson.ImageData.length==0'>
                          <mat-icon>border_color</mat-icon>
                          Signature
                        </span>

                        <!-- Signature Stamp-->
                        <div class="sig-cell"
                          *ngIf='item.fieldJson.signatureBase64 || item.fieldJson.signatureText && !item.fieldJson.signatureBase64 || item.fieldJson.ImageData.length>0'
                          [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                              <img *ngIf='item.fieldJson.signatureBase64' [src]="item.fieldJson.signatureBase64" />
                              <ng-container *ngIf='item.fieldJson.signatureText && !item.fieldJson.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': item.fieldJson.signInitialFontFamily}">
                                  {{item.fieldJson.signatureText}}</h3>
                              </ng-container>

                              <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData"
                                [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" />
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="contorlTools">
                        <div class="lhOpt">

                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="setWidth(data,item)"  mat-icon-button matTooltipClass="tooltip" matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button> 
                
                          <button (click)="centerBlock(data,item)"   mat-icon-button matTooltipClass="tooltip" matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer" *ngIf="item.fieldJson.fieldTypeName=='Initials'"
                      (click)="OpentoolDetail('Initials')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('Initials')" (click)="OpentoolDetailText(data,item.id,$event)">
                       
                        {{item.fieldJson.labelName}}</label>

                      <div class="customUpdate" (click)="OpentoolDetail('Initials')"
                        (click)="OpentoolDetailText(data,item.id,$event)"
                        (click)="OpenSignPopup(AddSignature,data,item,$event)">
                        <span
                          *ngIf='!item.fieldJson.signatureBase64 && !item.fieldJson.signatureText && item.fieldJson.ImageData.length==0'>
                          <mat-icon>gesture</mat-icon>
                          Initials
                        </span>
                        <!-- Signature Stamp-->
                        <div class="sig-cell"
                          *ngIf='item.fieldJson.signatureBase64 || item.fieldJson.signatureText && !item.fieldJson.signatureBase64 || item.fieldJson.ImageData.length>0'
                          [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                          <div class="sig-chrome"
                            [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                            <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics</div>
                            <div class="sig-container"
                              [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                              <img *ngIf='item.fieldJson.signatureBase64' [src]="item.fieldJson.signatureBase64" />
                              <ng-container *ngIf='item.fieldJson.signatureText && !item.fieldJson.signatureBase64'>
                                <h3 [ngStyle]="{'font-family': item.fieldJson.signInitialFontFamily}">
                                  {{item.fieldJson.signatureText}}</h3>
                              </ng-container>

                              <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData"
                                [ngStyle]="{'height': item.fieldJson.offsetHeight +'px', 'width': item.fieldJson.offsetWidth +'px'}">
                                <img [src]="img.Imageurl" />
                              </div>

                            </div>

                          </div>
                        </div>

                      </div>

                      <div class="contorlTools">
                        <div class="lhOpt">
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>


                    <section class="controlContainer customUpdate" *ngIf="item.fieldJson.fieldTypeName=='Image'"
                      (click)="OpentoolDetail('Image')" (click)="OpentoolDetailText(data,item.id,$event)">
                      <label (click)="OpentoolDetail('Image')" (click)="OpentoolDetailText(data,item.id,$event)">
                        
                        {{item.fieldJson.labelName}}</label>

                      <div (click)="OpentoolDetail('Image')" (click)="OpentoolDetailText(data,item.id,$event)"
                        class="fileOuter">

                        <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData forImageContorl">
                          <img *ngIf='img.Imageurl' [src]="img.Imageurl" />
                        </div>

                        <span *ngIf='item.fieldJson.ImageData.length==0'>
                          <mat-icon>cloud_upload</mat-icon>
                          Upload Image
                        </span>


                        <input type="file" class="form-control" (change)="onSelectImage($event,data,item.id)"
                          accept="image/*" placeholder="{{item.fieldJson.fieldName}}" />

                      </div>

                      <!-- <div (click)="OpentoolDetail('Image')" (click)="OpentoolDetailText(data,item.id,$event)">
                <span *ngIf='item.fieldJson.ImageData.length==0'>
                  <mat-icon>cloud_upload</mat-icon>
                  Upload Image
                </span>

                <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData">
                  <img *ngIf='img.Imageurl' [src]="img.Imageurl"/> 
                </div>                 
             
               <input type="file" class="form-control" (change)="onSelectImage($event,data,item.id)"
                accept="image/*" placeholder="{{item.fieldJson.fieldName}}"/>
              </div>   -->


                      <div class="contorlTools">
                        <div class="lhOpt">


                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->

                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>

                      </div>
                    </section>

                    <section class="controlContainer customUpdate" *ngIf="item.fieldJson.fieldTypeName=='embedImage'"
                      (click)="OpentoolDetail('embedImage')" (click)="OpentoolDetailText(data,item.id,$event)">
                      
                      <div (click)="OpentoolDetail('embedImage')" (click)="OpentoolDetailText(data,item.id,$event)"
                        class="fileOuter">

                        <div *ngFor="let img of item.fieldJson.ImageData" class="uploadedData embedImage">
                          <img *ngIf='img.Imageurl' [src]="img.Imageurl"
                            />
                        </div>

                        <span *ngIf='item.fieldJson.ImageData.length==0'>
                          <mat-icon>cloud_upload</mat-icon>
                          Upload Image
                        </span>
                        <input type="file" class="form-control" (change)="onSelectImage($event,data,item.id)"
                          accept="image/*" placeholder="{{item.fieldJson.fieldName}}" />

                      </div>

                      <div class="contorlTools">
                        <div class="lhOpt">
                          <!-- <button (click)="FullWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Full Width">
                            <mat-icon>border_horizontal</mat-icon>
                          </button>

                          <button (click)="HalfWidth(data,item)"
                            [color]="data.IsFullWidth != true ? 'primary' : 'basic'" mat-icon-button
                            matTooltipClass="tooltip" matTooltip="Half Width">
                            <mat-icon>border_vertical</mat-icon>
                          </button> -->
                          <button color="basic" cdkDragHandle class="move" mat-icon-button matTooltipClass="tooltip"
                          matTooltip="Move Control">
                          <mat-icon>drag_indicator</mat-icon>
                        </button>
                          <button (click)="setWidth(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Width">
                            <mat-icon>width_normal</mat-icon>
                          </button>

                          <button (click)="centerBlock(data,item)" mat-icon-button matTooltipClass="tooltip"
                            matTooltip="Alignment">
                            <mat-icon>format_align_center</mat-icon>
                          </button>

                        </div>

                        <div class="rhOpt">
                          <button (click)="CloneControl(data,item.id,item,item.fieldJson)" color="" class=""
                            mat-icon-button matTooltipClass="tooltip" matTooltip="Clone">
                            <mat-icon>content_copy</mat-icon>
                          </button>

                          <button color="warn" class="" mat-icon-button matTooltipClass="tooltip" matTooltip="Remove"
                            (click)="deleteSelectedControls(data,item.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </section>





                  </section>
                </ng-container>

              </ng-container>

            </section>

          </div>
        </form>
      </div>

      <ng-container *ngIf="ShowFooter">
        <ng-container *ngFor="let item of HeaderFooter">
          <div class="iframe-drag-bounds-footer" *ngIf="item.type=='Footer'">
            <div class="customUpdate">

              <span *ngIf='item.ImageData.length==0'>
                <mat-icon>cloud_upload</mat-icon>
                Click anywhere to upload logo (300*80) preferred size.
              </span>

              <div *ngFor="let img of item.ImageData" class="uploadedData">
                <img *ngIf='img.Imageurl' [src]="img.Imageurl" />
              </div>

              <input type="file" class="form-control" (change)="onSelectImageForHeaderFooter($event,'Footer')"
                accept="image/*">

            </div>
          </div>
        </ng-container>
      </ng-container>

     
           <!-- <div *ngIf="ShowFooter" class="iframe-drag-bounds-footer">
        <div class="customUpdate">
          <input type="file">
          <span>Click anywhere to upload banner image</span>
        </div>
      </div> -->
    </div>

  </div>

  <mat-card class="rblockPanel">
    <div cdkDropList class="example-list" (cdkDropListDropped)="drops($event)">
      <div class="example-box" *ngFor="let step of  this.controlAlignArray" (click)="GoToPage(step.step)" cdkDrag>
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <span class="numberp" [ngClass]="{'active' :step.step == currentStep}">{{step.step}}</span>{{step.pageName}}
        <button class="delPage" (click)="DeleteStep(step.step)" mat-icon-button
          color="warn"><mat-icon>delete</mat-icon></button>
      </div>
    </div>

  </mat-card>
  <div class="roblockOverlay active" (click)="openRightPanel()" [ngClass]="{'active' : openRight}"></div>

  <mat-card class="toolDetail open" [ngClass]="{'open': ShowtoolDetail, 'openInDevice': openInDevice}">
    <div class="blockC selected" style="flex-direction: row; justify-content: space-between; align-items: center;">
      <div class="xrow" *ngIf="Ssingleline">
        <mat-icon>power_input</mat-icon>Single-Line
      </div>
      <div class="xrow" *ngIf="SHtmlEditor">
        <mat-icon> format_shapes</mat-icon>Html Editor
      </div>
      <div class="xrow" *ngIf="Smultiline">
        <mat-icon>dehaze</mat-icon>Multi-Line
      </div>
      <div class="xrow" *ngIf="hText">
        <mat-icon>power_input</mat-icon>Header Text
      </div>
      <div class="xrow" *ngIf="Snumber">
        <mat-icon>filter_1</mat-icon>Number
      </div>
      <div class="xrow" *ngIf="Sradio">
        <mat-icon>radio_button_checked</mat-icon>Radio
      </div>
      <div class="xrow" *ngIf="Sdropdown">
        <mat-icon>arrow_drop_down_circle</mat-icon>Dropdown
      </div>
      <div class="xrow" *ngIf="SMCQ">
        <mat-icon>check_circle_outline</mat-icon>MCQ
      </div>
      <!-- <div class="xrow" *ngIf="SMCQ">
        <mat-icon>check_circle_outline</mat-icon>MCQ
      </div> -->
      <div class="xrow" *ngIf="STrueFalse">
        <mat-icon>check_circle_outline</mat-icon>True Or False
      </div>
      <div class="xrow" *ngIf="SRating">
        <mat-icon>check_circle_outline</mat-icon>Rating
      </div>
      <div class="xrow" *ngIf="SFeedback">
        <mat-icon>check_circle_outline</mat-icon>Feedback
      </div>
      <div class="xrow" *ngIf="Smuldropdown">
        <mat-icon>arrow_drop_down_circle</mat-icon>MultiSelect Dropdown
      </div>
      <div class="xrow" *ngIf="Scheckbox">
        <mat-icon>check_box</mat-icon>Check Box
      </div>
      <div class="xrow" *ngIf="Scheckboxgroup">
        <mat-icon>check_box</mat-icon>Check Box
      </div>
      <div class="xrow" *ngIf="Sbullet">
        <mat-icon>format_list_bulleted</mat-icon>Bullet List
      </div>
      <div class="xrow" *ngIf="Stable">
        <mat-icon>table_chart</mat-icon>Table
      </div>

      <div class="xrow" *ngIf="Sdraw">
        <mat-icon>brush</mat-icon>Draw
      </div>
      <div class="xrow" *ngIf="Smeasure">
        <mat-icon>straighten</mat-icon>Measure
      </div>
      <div class="xrow" *ngIf="Sline">
        <mat-icon>minimize</mat-icon>Straight line
      </div>
      <div class="xrow" *ngIf="Sthrough">
        <mat-icon>strikethrough_s</mat-icon>Strike through
      </div>
      <div class="xrow" *ngIf="SwhiteOut">
        <mat-icon>outbond</mat-icon>White Out
      </div>
      <div class="xrow" *ngIf="ShighLight">
        <mat-icon>highlight_alt</mat-icon>High Light
      </div>

      <div class="xrow" *ngIf="Ssignature">
        <mat-icon>create</mat-icon>Signature
      </div>
      <div class="xrow" *ngIf="Sinitials">
        <mat-icon>gesture</mat-icon>Initials
      </div>

      <div class="xrow" *ngIf="Sapproval">
        <mat-icon>done</mat-icon>{{acceptOrdeclineText}}
      </div>
      <div class="xrow" *ngIf="Sdate">
        <mat-icon>event_available</mat-icon>Date
      </div>
      <div class="xrow" *ngIf="Stime">
        <mat-icon>schedule</mat-icon>Time
      </div>
      <div class="xrow" *ngIf="Slocation">
        <mat-icon>location_on</mat-icon>Location
      </div>

      <div class="xrow" *ngIf="Sfile">
        <mat-icon>insert_drive_file</mat-icon>File
      </div>
      <div class="xrow" *ngIf="Simage">
        <mat-icon>wallpaper</mat-icon>Image
      </div>
      <div class="xrow" *ngIf="SbuttonLabel">
        <mat-icon>smart_button</mat-icon>Button
      </div>
      <div class="xrow" *ngIf="SURLL">
        <mat-icon>smart_button</mat-icon>URL
      </div>
      <div class="xrow" *ngIf="spaceBar">
        <mat-icon>smart_button</mat-icon>Top Bottom Space
      </div>
      <button mat-icon-button (click)="closeDetail()"><mat-icon>close</mat-icon></button>

    </div>

    <div class="allToolDetail">

      <div class="blockC Required" *ngIf="!hText">
        <div class="xrow mtb5">
          <div class="poscheck" *ngIf="SelectedControl!='HtmlEditor'">
            <label>
              <mat-checkbox
                *ngIf="SelectedControl!='URL' && SelectedControl!='Space' && SelectedControl!='Devider' && SelectedControl!='Paragraph' && SelectedControl!='TextSingle' "
                color="primary" [(ngModel)]="isRequired" (change)="checkBoxRequiredEvent($event)">Required
              </mat-checkbox>

            </label>
          </div>

        <div class="poscheck" *ngIf="SelectedControl!='HtmlEditor'">
            <label>
              <mat-checkbox color="primary" [(ngModel)]="isShowListing" (change)="checkBoxShowListingEvent($event)">Hide
                in Listing
              </mat-checkbox>
            </label>
          </div>


          <div class="poscheck" *ngIf="SreadOnly">
            <label>
              <mat-checkbox color="primary" [(ngModel)]="readonly" (change)="checkBoxReadOnlyEvent($event)">Read only
              </mat-checkbox>
            </label>
          </div>
        </div>
        <div class="poscheck"
          *ngIf="
          !hText 
          && SelectedControl!='HtmlEditor' 
          && SelectedControl!='Feedback' 
          && SelectedControl!='Rating' 
          && SelectedControl!='TrueFalse' 
          && SelectedControl!='URL' 
          && SelectedControl!='Space' 
          && SelectedControl!='Devider' 
          && SelectedControl!='MCQ'  
          && SelectedControl!='Paragraph' 
          && SelectedControl!='TextSingle'">
          <mat-form-field class="example-full-width">
            <mat-label>Label name</mat-label>
            <input matInput [(ngModel)]="LabelName" (input)="onChangeLabelName($event.target.value)" />
          </mat-form-field>
        </div>

        <div class="poscheck" *ngIf="!hText && !Scheckbox
      && !Stable && SelectedControl!='HtmlEditor' && SelectedControl!='Feedback' && SelectedControl!='Rating' && SelectedControl!='TrueFalse' && !SMCQ && !Sdropdown && !Ssignature && !Sbutton
      && !Slocation && !Sinitials && !Sdate && !Stime
      && !Sfile && !Simage && !SbuttonLabel">
          <mat-form-field class="example-full-width">
            <mat-label>
              
             
              <span *ngIf="SelectedControl!='URL'"> Placeholder name</span>
              <span *ngIf="SelectedControl=='URL'">Url Name</span>

            </mat-label>

            

            <input matInput [(ngModel)]="FeildName" (input)="onChangeFeildName($event.target.value)" />
          </mat-form-field>
        </div>
      </div>




      <div class="blockC xyposition dropOptions" *ngIf="Sdropdown || SMCQ">
        <div class="lab">Options</div>
        <div class="yrow mtb5" [ngClass]="{'disableDiv': dropdownddisabled}">
          <div class="sblab">Add list of options</div>

          <div *ngFor="let row of dropdownFieldArray; let i = index" class="opt">
            <mat-icon>fiber_manual_record</mat-icon>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="Option {{i+1}}" [(ngModel)]="row.val"
                (input)="onChangedropdownlist($event.target.value)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>
            <button mat-icon-button *ngIf="!dropdownddisabled">
              <mat-icon (click)="deleteField('d',row)">close</mat-icon>
            </button>
          </div>
          <div class="opt" *ngIf="!dropdownddisabled">
            <button color="primary" (click)="addValueFielDropDown()" mat-icon-button>
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>



      <div class="blockC xyposition dropOptions" *ngIf="Scheckbox">
        <div class="lab">Checkbox buttons</div>
        <div class="yrow mtb5" [ngClass]="{'disableDiv': checkboxdisabled}">
          <div class="sblab">Add list of values</div>

          <div *ngFor="let row of checkboxFieldArray; let i = index" class="opt">
            <mat-icon>check_box_outline_blank</mat-icon>
            <mat-form-field class="example-full-width">
              <mat-label>Label</mat-label>
              <input matInput placeholder="Add Label" value="" [(ngModel)]="row.val"
                (input)="onChangecheckboxlist($event.target.value)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>

          </div>

        </div>
      </div>

      <div class="blockC xyposition" *ngIf="Scheckboxgroup">
        <div class="lab">Checkbox buttons</div>
        <div class="yrow mtb5" [ngClass]="{'disableDiv': checkboxdisabled}">
          <div class="sblab">Add list of values</div>

          <div *ngFor="let row of checkboxGroupFieldArray; let i = index" class="opt">
            <mat-icon>check_box_outline_blank</mat-icon>
            <mat-form-field class="example-full-width">
              <mat-label>Label</mat-label>
              <input matInput placeholder="Add Label" value="" [(ngModel)]="row.val"
                (input)="onChangecheckboxGrouplist($event.target.value,row)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>

            <button mat-icon-button>
              <mat-icon (click)="deleteField('c',row)">close</mat-icon>
            </button>
          </div>

        </div>
      </div>

      <div class="blockC xyposition" *ngIf="Stable">
        <div class="lab">Table</div>
        <div class="xrow mtb5">
          <div class="pos">Rows <input type="text" id='txt-tbl-row' maxlength="2" [(ngModel)]="tblrowsnumber"
              (input)="onChangetblrows($event.target.value)" /></div>
          <div class="pos">Columns <input type="text" id='txt-tbl-column' maxlength="2" [(ngModel)]="tblclmnumber"
              (input)="onChangetblclm($event.target.value)" /></div>
        </div>
      </div>


      <div class="blockC" *ngIf="Sbutton">
        <div class="xrow mtb5">
          <div class="poscheck">
            <label>
              <input type="radio" [checked]="acceptchecked" (click)='OnAcceptOrDecline($event,true)' name="button"
                value="" /> Approve
            </label>
          </div>
          <div class="poscheck">
            <label>
              <input type="radio" [checked]="declinechecked" (click)='OnAcceptOrDecline($event,false)' name="button"
                value="" /> Decline
            </label>
          </div>
        </div>
      </div>

      <div class="blockC" *ngIf="Stext && SelectedControl!='HtmlEditor'">
        <div class="lab">Add Text</div>
        <div class="xrow txtarea">
          <textarea [(ngModel)]="text" [maxlength]="characterlimit" *ngIf="SelectedControl!='URL'"
            (input)="onChangeText($event.target.value)"></textarea>
          <textarea [(ngModel)]="text" *ngIf="SelectedControl=='URL'"
            (input)="onChangeText($event.target.value)"></textarea>
        </div>
        <!-- <div class="xrow limit">      
        <input type="text" [(ngModel)]="characterlimit" (input)="onChangeCharLimit($event.target.value)" />
        <span>Set Character Limit</span>
      </div> -->
      </div>

      <div class="blockC" *ngIf="SButtontext">
        <div class="lab">Add Text</div>
        <div class="xrow txtarea">
          <textarea [(ngModel)]="buttonText" (input)="onChangeTextButton($event.target.value)"></textarea>
        </div>
      </div>


      <div class="blockC" *ngIf="SURL">
        <div class="lab">Add URL</div>
        <div class="xrow txtarea">
          <input matInput type="url" name="url" id="url" placeholder="https://example.com" pattern="https://.*"
            [(ngModel)]="buttonURL" (input)="onChangeUrlButton($event.target.value)">
        </div>
      </div>


      <div class="blockC" *ngIf="Snumber">
        <div class="lab">Add Value</div>
        <div class="xrow ">
          <input type="number" pattern="[0-9]+([\.,][0-9]+)?" value="$" [(ngModel)]="text"
            (input)="onChangeNumberValue($event.target.value)" />
        </div>
      </div>

      <div class="blockC" *ngIf="Sformat">
        <div class="lab">Formatting</div>
        <div class="xrow mtb5 sizenfont">

          <mat-form-field appearance="outline" class="fsize">
            <mat-label>Font Size</mat-label>
            <mat-select [(ngModel)]="fontsize" (selectionChange)="onChangeFontSize($event)">
              <mat-option *ngFor="let font of fontSize" [value]="font.fontsize">
                {{font.fontsize}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="fontfam">
            <mat-label>Font Family</mat-label>
            <mat-select [(ngModel)]="fontfamily" (selectionChange)="onChangeFontFamily($event)">
              <mat-option *ngFor="let fam of fontfamilys" [value]="fam.font">
                {{fam.font}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="yrow iconsAll" *ngIf="!hText">

          <div class="mb-10">
            <mat-button-toggle-group #group="matButtonToggleGroup">
              <mat-button-toggle value="left" aria-label="Text align left" mat-icon-button
                [ngClass]="{active : textalign == 'left'}" (click)="onChangeTextAlign('left')">
                <mat-icon>format_align_left</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="center" aria-label="Text align center"
                [ngClass]="{active : textalign == 'center'}" (click)="onChangeTextAlign('center')">
                <mat-icon>format_align_center</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="right" aria-label="Text align right" [ngClass]="{active : textalign == 'right'}"
                (click)="onChangeTextAlign('right')">
                <mat-icon>format_align_right</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="justify" aria-label="Text align justify"
                [ngClass]="{active : textalign == 'justify'}" (click)="onChangeTextAlign('justify')">
                <mat-icon>format_align_justify</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>


          <div class="mb-10">
            <mat-button-toggle-group #group2="matButtonToggleGroup">
              <mat-button-toggle value="left" aria-label="Text Bold" [ngClass]="{active : fontstyle === 'bold'}"
                (click)="onChangeTextBoldFont('bold')">
                <mat-icon>format_bold</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="center" aria-label="Text Italic" [ngClass]="{active : fontweight === 'italic'}"
                (click)="onChangeTextItalicFont('italic')">
                <mat-icon>format_italic</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="right" aria-label="Text Underline"
                [ngClass]="{active : textdecoration === 'underline'}" (click)="onChangeTextDecoration('underline')">
                <mat-icon>format_underlined</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="justify" aria-label="Text Strike Through"
                [ngClass]="{active : textdecoration === 'line-through'}"
                (click)="onChangeTextDecoration('line-through')">
                <mat-icon>strikethrough_s</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

        </div>

        <div class="xrow">

        </div>

        <div class="xrow tcolor">
          <div class="txtColor">
            <div class="textViewColor" [ngStyle]="{'background':textColor}"></div>
            <input type="color" class="" [(ngModel)]="textColor" (input)="onChangeFontColor($event.target.value)" />
          </div>
          <span>font color</span>
        </div>

        <div class="xrow tcolor" *ngIf="backgroundColorshow==true">
          <div class="txtColor">
            <div class="textViewColorButton" [ngStyle]="{'background':backgroundColor}"></div>
            <input type="color" class="" [(ngModel)]="backgroundColor" (input)="onChangeBackgroundColor($event.target.value)" />
          </div>
          <span>background color</span>
        </div>

      </div>

      <div class="blockC" *ngIf="Sdraw || Ssignature">
        <div class="lab">Draw</div>
        <div class="xrow tcolor">
          <div class="textViewColor" [ngStyle]="{'background':'rgba(' + brushColor + ')'}"></div>
          <input type="color" class="" [(ngModel)]="brushColor" (input)="onBrushColorChange($event.target.value)" />
          <span>Select color</span>
        </div>
      </div>


      <div class="blockC" *ngIf="spaceBar">
        <div class="lab">Select Space from top</div>
        <div class="xrow tcolor">  
          <mat-select [(ngModel)]="fontsize" (selectionChange)="onChangeSpaceMarginSize($event)">
            <mat-option *ngFor="let font of fontSize" [value]="font.fontsize">
              {{font.fontsize}}
            </mat-option>
          </mat-select>

        </div>
      </div>

      <div class="blockC" *ngIf="SAItext">
     
      
        <div class="lab">Add Question</div>
        <div class="xrow txtarea">
          <textarea [(ngModel)]="text" 
            (input)="onChangeTextAIQestion($event.target.value)"></textarea>
        </div>
      
  
        <div class="pageSearch">
          <label>AI Document Search</label>
        <input type="text" [(ngModel)]="Pagenumbers" class="pageNumber" placeholder="Enter page number"   >
        <p>Note:- Specify Page numbers for AI reading. If left blank, default search is first 5 pages</p>
        </div>
  
        <button class="runAI" mat-stroked-button color="primary" matTooltip="Run AI" mat-button (click)="GetResponseFromAIDoc(selectedAIDocs)">
         Run AI
        </button>
       
      </div>
  
      <div class="blockC" *ngIf="SAItext">
  
        <div>
          <ng-container *ngFor="let document of selectedAIDocs">
      
      
            <span class="documentList">
              <div class="userpic">
                <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
              </div>
              <div class="info">
                <a href="{{document.documentPath}}" target="_blank"> {{document.documentName}}</a>
                <button matTooltip="Unmap document" mat-icon-button (click)="DeleteAIDocuments(document)">
                  <mat-icon>delete</mat-icon>
                </button>
   
              </div>
            </span>
          </ng-container>
        </div>
  
  
     
        <div class="upDoc aiUploader">
          <div class="uploadholder">
            <input #Input type="file" multiple (change)="selectFilesFromDragZone($event)" />
              Drag and drop files here         
          </div>
        </div>
       
  
        <button mat-flat-button (click)="selectDocuments(selectDocumentsId)">
          <mat-icon>remove_red_eye</mat-icon>
          View and map documents
        </button>
        
  
      </div>


    </div>

    <div class="blockC xyposition" *ngIf="!hText && SelectedControl!='HtmlEditor'">
      <button mat-stroked-button color="warn" (click)="deleteSelectedControl()">Delete</button>
    </div>


  </mat-card>
</div>



<ng-template #AIPdfpopUp>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>picture_as_pdf</mat-icon>
    </span>
    Run AI
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
     
        <div class="upDoc aiUploader">
          <div class="uploadholder">
            <input #Input type="file" multiple (change)="selectFilesFromDragZoneOuter($event,aiDocListWithDetailForOuter)" />
              Drag and drop files here          
          </div>
        

          
        </div>

        <ng-container *ngFor="let document of selectedAIDocsOUter">
        
          <span class="documentList mt-15">
            <div class="userpic">
              <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
            </div>
            <div class="info">
              <a href="{{document.documentPath}}" target="_blank"> {{document.documentName}}</a>
            </div>
          </span>
        </ng-container>

        <div class="singleQuestion" *ngFor="let qs of aiDocListWithDetailForOuter; index as i ">
          
          <h4>Q{{i+1}}: {{qs.question}}</h4>

          <button class="runAI" mat-stroked-button color="primary" matTooltip="Run AI" mat-button (click)="GetResponseFromAIDocOuter(qs)">
           Run AI
          </button>

           <mat-icon *ngIf="qs.isCompleted==true">check_circle</mat-icon>
         
         </div>

 
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="basic" (click)="close()">Close</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #selectDocumentsId>
  <h2 mat-dialog-title>
    <!-- <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span> -->
    Select Document

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <span *ngIf="showDocumentsToselectInPopup.length==0">
      Currently, there are no documents available for mapping. We kindly request you to upload a document that requires mapping for further processing and analysis. 
    </span>
    <ul class="selectedlist">
      <li *ngFor="let document of showDocumentsToselectInPopup">
          <span (click)="MapDocToControls(document)" class="documentList">
            <div class="userpic">
              <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
            </div>
            <div class="info">
              <!-- <a href="{{document.documentPath}}" target="_blank">  -->
                {{document.documentName}}
              <!-- </a> -->

              <!-- <button mat-icon-button (click)="DeleteAIDocuments(document)">
                <mat-icon>delete</mat-icon>
              </button> -->
 
            </div>
          </span>
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #NewMultiSelectPopup>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create_new_folder</mat-icon>
    </span>
    Select Items
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="allControls">

      <div class="items">
        <span>Select New Items</span>

        <ng-container *ngFor="let m of multiSelectCurrentItem.fillList">
          <label (click)="AddMultiSelectItem(m.val,multiSelectCurrentItem)"> {{m.val}} </label>
        </ng-container>
      </div>
      <div class="show_icon">
        <mat-icon>sync_alt</mat-icon>
      </div>
      <div class="items selected">
        <span>Selected Items</span>

        <ng-container *ngFor="let s of multiSelectCurrentItem.selectedValue;">
          <label (click)="removeMultiSelectItem(s,multiSelectCurrentItem)"> {{s}}</label>
        </ng-container>

        <ng-container *ngIf="multiSelectCurrentItem.selectedValue.length == 0">
          <p>No item selected</p>
        </ng-container>


      </div>
    </div>
  </mat-dialog-content>
</ng-template>

<app-create-fillable-fields (closeSlide)="closecreateField($event)" [ngClass]="{ open: showSidePanel }">
</app-create-fillable-fields>

<ng-template #AddSignature>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create</mat-icon>
    </span>
    Add Signature
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">

      <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
          <mat-radio-button value="draw" (change)="radioChangeSign()">Draw</mat-radio-button>
          <mat-radio-button value="upload" (change)="radioChangeSign()">Upload</mat-radio-button>
          <mat-radio-button value="type" (change)="radioChangeSign()">Type In</mat-radio-button>
        </mat-radio-group>
      </div>



      <div class="allSCont">
        <ng-container *ngIf="signOpt == 'upload'">
          <div class="uploadholder">
            <mat-icon>note_add</mat-icon>
            <p *ngIf="filenameForSign == '' ">Drop your signature here or click here to upload</p>
            <span *ngIf="filenameForSign == '' ">File extension should be .png</span>
            <p>{{filenameForSign}}</p>
            <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
              placeholder="Add file">
          </div>
        </ng-container>

        <ng-container *ngIf="signOpt == 'draw'">
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
        </ng-container>

        <ng-container *ngIf="signOpt == 'type'">
          <div class="divideCol">
            <div class="left blk">
              <mat-form-field>
                <mat-label>Enter Name</mat-label>
                <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                  (ngModelChange)="signOrInitialTextChanges($event)">
              </mat-form-field>
            </div>
            <div class="right blk">
              <mat-form-field appearance="fill">
                <mat-label>Select font family</mat-label>
                <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                  <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="allSign">
            <div class="signlook" [ngStyle]="{'font-family': selected}">
              {{signName}}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <span>
      <button mat-stroked-button color="primary" *ngIf="signaturePad != undefined"
        (click)="clearSignature()">Clear</button>
      <button mat-flat-button (click)="addSignature()" color="primary" [disabled]="!SignButtonEnable">Sign</button>
    </span>
  </mat-dialog-actions>
</ng-template>

<ng-template #Draw>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>brush</mat-icon>
    </span>
    Draw
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">




      <div class="allSCont">

        <ng-container>
          <signature-pad id="drawCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
            (onEndEvent)="drawComplete()"></signature-pad>
        </ng-container>


      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addDrawnImg()" color="primary">Draw</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #AddInitial>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>gesture</mat-icon>
    </span>
    Add Initials
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">
      <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
          <mat-radio-button value="draw" (change)="radioChangeInitails()">Draw</mat-radio-button>
          <mat-radio-button value="upload" (change)="radioChangeInitails()">Upload</mat-radio-button>
          <mat-radio-button value="type" (change)="radioChangeInitails()">Type In</mat-radio-button>
        </mat-radio-group>
      </div>



      <div class="allSCont">
        <ng-container *ngIf="signOpt == 'upload'">
          <div class="uploadholder">
            <mat-icon>note_add</mat-icon>
            <p>Drop your initials here or click here to upload</p>
            <span>File extension should be .png</span>
            <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
              placeholder="Add file">
          </div>
        </ng-container>

        <ng-container *ngIf="signOpt == 'draw'">
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
        </ng-container>

        <ng-container *ngIf="signOpt == 'type'">
          <div class="divideCol">
            <div class="left blk">
              <mat-form-field>
                <mat-label>Enter Name</mat-label>
                <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                  (ngModelChange)="signOrInitialTextChanges($event)">
              </mat-form-field>
            </div>
            <div class="right blk">
              <mat-form-field appearance="fill">
                <mat-label>Select font family</mat-label>
                <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                  <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="allSign">
            <div class="signlook" [ngStyle]="{'font-family': selected}">
              {{signName}}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addSignature()" color="primary" [disabled]="!InitailButtonEnable">Sign</button>
  </mat-dialog-actions>
</ng-template>



<ng-template #saveTemp>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>folder</mat-icon></span>
    Select Required Action
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </h2>

  <mat-dialog-content class="mat-typography">


    <div *ngIf="MasterTemplateGlobalWebForm==true" class="cateAdd">
      <mat-form-field class="">
        <mat-label>Select Template Category</mat-label>
        <mat-select [(value)]="MasterTemplatecategoryID" (selectionChange)="SelectCategoryType($event)">
          <mat-option *ngFor="let template of CategoryTypeList" [value]="template.categoryID">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button  mat-icon-button color="primary" (click)="openDialogForAddCategory()"> <mat-icon>add</mat-icon> </button>
    </div>

    <div class="saveTemplate" *ngIf="MasterTemplateWebFormAdd==true">
      <mat-radio-group color="primary" aria-label="Select an option">    
        <mat-radio-button value="1" [checked]="isSendEnabled==true"  (change)="OnSelectaboutSaveTemplate1('1')">Save Template Only</mat-radio-button>
        <mat-radio-button value="2" *ngIf="showOrgnizationLevelCheckbox==true" (change)="OnSelectaboutSaveTemplate1('2')">Save as Organization Template</mat-radio-button>
      </mat-radio-group>    
     </div>

     
     <div class="cateAdd" *ngIf="MasterOrgTemplateWebFormEdit==true">
      <mat-form-field class="">
        <mat-label>Select Template Category</mat-label>
        <mat-select  [(value)]="OrganizationCategoryId" (selectionChange)="SelectOrganizationCategoryType($event)">
          <mat-option *ngFor="let template of OrganizationLeveltemplateList" [value]="template.categoryID">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button  mat-icon-button color="primary" (click)="AddOrgTemCatDialog()"> <mat-icon>add</mat-icon> </button>
      
    </div>

    
     <div class="cateAdd" *ngIf="showOrganizationTempCategory==true">
      <mat-form-field class="">
        <mat-label>Select Template Category</mat-label>
        <mat-select  (selectionChange)="SelectOrganizationCategoryType($event)">
          <mat-option *ngFor="let template of OrganizationLeveltemplateList" [value]="template.categoryID">
            {{ template.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <button  mat-icon-button color="primary" (click)="AddOrgTemCatDialog()"> <mat-icon>add</mat-icon> </button>
      
    </div>


   

    <ng-container>
      <div class="sepBlock" *ngIf="showFormFolder==true">

        <div class="block">

          <h3>
            Select folder to save template
          </h3>

          <div class="taskLocation">
            <span (click)="breadCrumbMyFormsMainClick()">Forms</span>
            <ng-container *ngFor="let m of breadCrumMenu ; let indx = index">
              <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
              <span>{{ m.formFolderName }}</span>
            </ng-container>

          </div>

          <div class="drive mainLink">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
              <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderName }"
                *matTreeNodeDef="let node ; let indx = index" matTreeNodePadding matTreeNodePaddingIndent="20">

                <div class="folderName" (click)="getFormFolderWithFormTemplates(node)">
                  <mat-icon *ngIf="node.isShared == false"
                    (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                  <mat-icon *ngIf="node.isShared == true"
                    (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                  <span (click)="getFormFolderWithFormTemplates(node)">{{ node.formFolderName }}</span>
                </div>
              </mat-tree-node>

              <mat-tree-node [ngClass]="{ 'active': activeNode === node.formFolderName }"
                *matTreeNodeDef="let node;when: hasChild ; let indx = index" matTreeNodePadding
                matTreeNodePaddingIndent="20">
                <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.formFolderName">
                  <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                    {{ treeControl.isExpanded(node) ? "arrow_drop_down" : "arrow_right" }}
                  </mat-icon>
                  <div class="folderName" (click)="getFormFolderWithFormTemplates(node)">
                    <mat-icon *ngIf="node.isShared == false"
                      (click)="getFormFolderWithFormTemplates(node)">folder</mat-icon>
                    <mat-icon *ngIf="node.isShared == true"
                      (click)="getFormFolderWithFormTemplates(node)">folder_shared</mat-icon>
                    <span (click)="getFormFolderWithFormTemplates(node)">{{ node.formFolderName }}</span>
                  </div>
                </div>
              </mat-tree-node>
            </mat-tree>
          </div>
        </div>



      </div>
    </ng-container>

  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>

    <button *ngIf="FormId==0" mat-flat-button color="primary" [disabled]="!savebuttonshow" (click)="AddHtMLForm()">
      Save <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>

    <button *ngIf="FormId>0" mat-flat-button color="primary" [disabled]="!savebuttonshow" (click)="UpdateHtMLForm()">
      Update <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
    </button>

  </mat-dialog-actions>
</ng-template>


<ng-template #PartyURLpopUp>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>assignment</mat-icon>
    </span>
     <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
     
    <mat-slide-toggle color="primary" (change)="change3rdPartyurl($event)" [checked]="isUrlParameterConfigured">
      3rd Party Url Accept Configuration
    </mat-slide-toggle>

    <div class="msgBlock party" *ngIf="isUrlParameterConfigured==true">
      <!-- <label>3rd Party Url Accept Configuration</label> -->

      <div class="">

        <mat-form-field  appearance="fill" class="example-full-width">
          <mat-label>Success URL</mat-label>
          <input matInput placeholder="" (input)="onSuccessURLChange($event.target.value)"
          [(ngModel)]="successUrl">
        </mat-form-field>

        <div *ngIf="showSuccessUrlMessage==true" style="color: red;">Invalid URL</div>

        <mat-form-field appearance="fill"  class="example-full-width">
          <mat-label>Decline URL</mat-label>
          <input matInput  placeholder="" (input)="onDeclineURLChange($event.target.value)"
          [(ngModel)]="declineUrl">
        </mat-form-field>

        <div *ngIf="showDeclineUrlMessage==true" style="color: red;">Invalid URL</div>

        <div class="">           

          <div class="subtaskHolder">
            <form [formGroup]="dynamicForm">
              <div formArrayName="filters">
                <div  *ngFor="let filter of filtersFormArray.controls; let i = index;">
    
                  <div class="rep" [formGroupName]="i">                
                    
                    <mat-form-field appearance="" class="mr-10" >
                      <mat-label>System Field</mat-label>
                      <mat-select placeholder="Select" formControlName="fieldID">
                        <mat-option *ngFor="let stat of coreDropdownList" [value]="stat.fieldID">
                          {{ stat.fieldName }}
                      </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label>Parameter Name</mat-label>
                      <input matInput formControlName="parameterName" placeholder="" maxlength="50">                     
                    </mat-form-field>      
                   
                    <button mat-icon-button class="remove" color="warn"
                      (click)="removeFilterFromFiltersFormArray(i,filter.value)">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>
    
                  </div>
                </div>
    
                <button class="subtask" mat-icon-button color="primary" (click)="addFilterToFiltersFormArray()">
                  <mat-icon>add</mat-icon>                
                </button>
    
              </div>
            </form>
          </div>

        </div>       

       
      </div>
    </div>
 
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="basic" (click)="close()">Close</button>
    <button *ngIf="FormId>0" mat-flat-button color="primary" [disabled]="!savebuttonshow" (click)="UpdateURL()">
      Save <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
     </mat-spinner></mat-icon>
   </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #ConfigureFormSelectionpopUp>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>assignment</mat-icon>
    </span>
     <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
     
    <mat-slide-toggle color="primary" (change)="changeFormSelectionParameter($event)" [checked]="isConfigureFormParameter">
      Configure Form Selection Parameter
    </mat-slide-toggle>

    <div class="msgBlock party" *ngIf="isConfigureFormParameter==true">     

      <div class="">      
       
        <div class="">           

          <div class="subtaskHolder">
            <form [formGroup]="dynamicFormParameter">
              <div formArrayName="filtersFormParameter">
                <div  *ngFor="let filter of filtersFormParameterArray.controls; let i = index;">
    
                  <div class="rep" [formGroupName]="i">                
                    
                    <mat-form-field >
                      <mat-label>Parameter Name</mat-label>
                      <input matInput formControlName="parameterName" placeholder="" maxlength="50">                       
                    </mat-form-field>  

                    <mat-form-field >
                      <mat-label>Value</mat-label>
                      <input matInput formControlName="value" placeholder="" maxlength="200">                        
                    </mat-form-field>      
                   
                    <button mat-icon-button class="remove" color="warn"
                      (click)="removeFormParameterFromFiltersFormArray(i,filter.value)">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>
    
                  </div>
                </div>
    
                <button class="subtask" mat-icon-button color="primary" (click)="addFormParameterFiltersFormArray()">
                  <mat-icon>add</mat-icon>                  
                </button>
    
              </div>
            </form>
          </div>

        </div>       

       
      </div>
    </div>
 
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="basic" (click)="close()">Close</button>
    <button *ngIf="FormId>0" mat-flat-button color="primary" [disabled]="!savebuttonshow" (click)="UpdateConfigureForm()">
      Save <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
     </mat-spinner></mat-icon>
   </button>
  </mat-dialog-actions>
</ng-template>

<style>
  .cke_notifications_area { display: none;}
</style>

<style>
  .cke_notification { display: none; }
</style>
<style>
  .cke_notification_warning { display: none; }
</style>

<style>
  .cke_notification_cke_notification_warning{ display: none !important; }
</style>